import { faEnvelope } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { Button, CardV2 as Card } from '@feathr/components';
import { useLocalUrl } from '@feathr/extender/state';

import * as styles from './ReceiptSettingsCard.css';

function ReceiptSettingsCard(): JSX.Element {
  const { t } = useTranslation();
  const history = useHistory();
  const localUrl = useLocalUrl();

  function handleClickSetup(): void {
    history.push(localUrl('/fundraise/receipt-settings'));
  }

  return (
    <div>
      <Card width={'full'}>
        <Card.Header
          description={t('Customize your donation receipt emails')}
          prefix={
            <div className={styles.iconContainer}>
              <FontAwesomeIcon className={styles.icon} icon={faEnvelope} />
            </div>
          }
          title={t('Receipt Settings')}
        >
          <Button onClick={handleClickSetup}>{t('Setup')}</Button>
        </Card.Header>
      </Card>
    </div>
  );
}

export default ReceiptSettingsCard;
